import { render, staticRenderFns } from "./ezviz-device.vue?vue&type=template&id=995fe93a&scoped=true"
import script from "./ezviz-device.vue?vue&type=script&lang=js"
export * from "./ezviz-device.vue?vue&type=script&lang=js"
import style0 from "./ezviz-device.vue?vue&type=style&index=0&id=995fe93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995fe93a",
  null
  
)

export default component.exports